<template>
  <v-snackbar v-model="snackbar" :timeout="3000">
    {{ notification }}
    <v-btn text color="pink" @click.native="snackbar = false">
      Sulge
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: false,
      notification: ''
    }
  },
  async created() {
    this.$eventBus.$on('notification', notification => {
      this.showNotification(notification)
    })
  },
  methods: {
    showNotification(notification) {
      this.notification = notification
      this.snackbar = true
    }
  }
}
</script>
